module.exports = __webpack_public_path__ + "static/img/packaged-fuel_256.9220e22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/packaged-fuel_256.png
// module id = bs8W
// module chunks = 0